import React, { useState } from 'react';

import { useSnackbar } from 'notistack';

import { LoopOutlined } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';

import { checkFraud } from '~/services/OrdersService';

interface Props {
  order: App.Order;
}

function FraudScoreDetails({ order }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const [isCheckingFraud, setIsCheckingFraud] = useState(false);
  const [recalculatedFraudScore, setRecalculatedFraudScore] = useState<number>();
  const [recalculatedFraudDescription, setRecalculatedFraudDescription] = useState<string>();

  const handleReRunFraudCheck = async () => {
    setIsCheckingFraud(true);
    try {
      const response = await checkFraud(order.id_orders);
      setRecalculatedFraudScore(response.score);
      setRecalculatedFraudDescription(response.fraudDesc);
    } catch {
      setRecalculatedFraudScore(undefined);
      setRecalculatedFraudDescription(undefined);
      enqueueSnackbar('Error fetching recalculated fraud check', { variant: 'error' });
    }
    setIsCheckingFraud(false);
  };

  return (
    <>
      <strong>Fraud Score: </strong>
      <Tooltip title={order.fraud_desc}>
        <span>{order.fraud_score}</span>
      </Tooltip>
      <Tooltip title="Re-run fraud check">
        <IconButton size="small" disabled={isCheckingFraud} onClick={handleReRunFraudCheck}>
          {isCheckingFraud ? <CircularProgress size={16} /> : <LoopOutlined />}
        </IconButton>
      </Tooltip>
      <br />
      {isCheckingFraud && <span>Loading...</span>}
      {recalculatedFraudScore !== undefined && !isCheckingFraud && (
        <Box>
          <strong>Recalculated Fraud Score: </strong>
          <Tooltip title={recalculatedFraudDescription}>
            <span>{recalculatedFraudScore}</span>
          </Tooltip>
        </Box>
      )}
    </>
  );
}

export { FraudScoreDetails };
